<ul class="internal-module-switcher">
  <li
    class="module-item"
    routerLinkActive="active"
    matTooltip="Multi Calendar"
    i18n-matTooltip
    *ngxPermissionsOnly="['canSeeMultiCalendar']"
  >
    <a routerLink="/calendar/multi"><i class="cs-icon cs-icon-calendar-alt"></i></a>
  </li>
  <li
    class="module-item"
    routerLinkActive="active"
    matTooltip="Standard Calendar"
    i18n-matTooltip
    *ngxPermissionsOnly="['canSeeStandardCalendar']"
  >
    <a routerLink="/calendar/standard"><i class="cs-icon cs-icon-calendar-day"></i></a>
  </li>
  <li
    class="module-item"
    routerLinkActive="active"
    matTooltip="Planning Calendar"
    i18n-matTooltip
    *ngxPermissionsOnly="['canSeePlanningCalendar']"
  >
    <a routerLink="/calendar/planning"><i class="cs-icon cs-icon-calendar-check"></i></a>
  </li>
  <li
    class="module-item"
    routerLinkActive="active"
    matTooltip="Agenda Calendar"
    i18n-matTooltip
    *ngxPermissionsOnly="['canSeeAgenda']"
  >
    <a routerLink="/calendar/agenda"><i class="cs-icon cs-icon-calendar-schedule"></i></a>
  </li>
  <li
    class="module-item"
    routerLinkActive="active"
    matTooltip="Hold Events"
    i18n-matTooltip
    *ngxPermissionsOnly="['canSeeHold']"
  >
    <a routerLink="/calendar/hold"><i class="cs-icon cs-icon-calendar-pause"></i></a>
  </li>
</ul>
